class DialogManager {
  constructor() {
    this.vueComponent = null;
    this.dialogs = {
      signin: { isOpen: false },
      signout: { isOpen: false },
      error: { isOpen: false, title: '', details: '' },
      cookie: { isOpen: false }
    };
    this.callbacks = {};
  }

  // Register the Vue component instance
  registerComponent(component) {
    this.vueComponent = component;
    console.log('DialogManager: Vue component registered');
  }

  // Unregister when component is destroyed
  unregisterComponent() {
    this.vueComponent = null;
    console.log('DialogManager: Vue component unregistered');
  }

  // Generic method to open any dialog
  openDialog(dialogName, options = {}) {
    if (this.vueComponent) {
      // Vue component is available - use reactive approach
      this.vueComponent.openDialog(dialogName, options);
    } else {
        console.error(`DialogManager: Vue component not registered for dialog ${dialogName}`);
      // Fallback to Bootstrap modal (for plain HTML)
      //this.openBootstrapModal(dialogName, options);
    }
  }

  // Specific dialog methods
  showSignIn() {
    this.openDialog('signin');
  }

  showSignOut() {
    this.openDialog('signout');
  }

  showError(title, details) {
    this.openDialog('error', { title, details });
  }

  showCookieConsent() {
    this.openDialog('cookie');
  }

  
}

// Create global instance
console.log("Creating DialogManager instance...");
window.dialogManager = new DialogManager();

export default window.dialogManager;